module.exports = __webpack_public_path__ + "static/media/resetPassword-logo.c0bab3d2.png";